(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    function extractSwatchColors() {
    const swatches = document.querySelectorAll('.swatch[data-swatch-image-url]:not([data-swatch-extracted])');
    if (!swatches.length) return;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });

    swatches.forEach((swatch) => {
      const url = swatch.getAttribute('data-swatch-image-url');
      if (!url) return;

      swatch.setAttribute('data-swatch-extracted', 'pending');

      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        const cx = Math.floor(img.naturalWidth / 2);
        const cy = Math.floor(img.naturalHeight / 2);
        const [r, g, b] = ctx.getImageData(cx, cy, 1, 1).data;
        const hex = '#' + [r, g, b].map((c) => c.toString(16).padStart(2, '0')).join('');
        swatch.style.setProperty('--swatch-background', hex);
        swatch.classList.remove('swatch--unavailable');
        swatch.setAttribute('data-swatch-extracted', hex);
      };
      img.src = url;
    });
  }

  extractSwatchColors();
  document.addEventListener('shopify:section:load', extractSwatchColors);

  let swatchDebounce;
  const debouncedExtract = () => {
    clearTimeout(swatchDebounce);
    swatchDebounce = setTimeout(extractSwatchColors, 50);
  };

  const swatchObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-swatch-extracted') {
        const el = mutation.target;
        if (el.hasAttribute('data-swatch-image-url') && !el.hasAttribute('data-swatch-extracted')) {
          debouncedExtract();
          return;
        }
      }
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.('.swatch[data-swatch-image-url]') || node.querySelector?.('.swatch[data-swatch-image-url]'))) {
          debouncedExtract();
          return;
        }
      }
    }
  });
  swatchObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-swatch-extracted'] });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    function extractSwatchColors() {
    const swatches = document.querySelectorAll('.swatch[data-swatch-image-url]:not([data-swatch-extracted])');
    if (!swatches.length) return;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });

    swatches.forEach((swatch) => {
      const url = swatch.getAttribute('data-swatch-image-url');
      if (!url) return;

      swatch.setAttribute('data-swatch-extracted', 'pending');

      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        const cx = Math.floor(img.naturalWidth / 2);
        const cy = Math.floor(img.naturalHeight / 2);
        const [r, g, b] = ctx.getImageData(cx, cy, 1, 1).data;
        const hex = '#' + [r, g, b].map((c) => c.toString(16).padStart(2, '0')).join('');
        swatch.style.setProperty('--swatch-background', hex);
        swatch.classList.remove('swatch--unavailable');
        swatch.setAttribute('data-swatch-extracted', hex);
      };
      img.src = url;
    });
  }

  extractSwatchColors();
  document.addEventListener('shopify:section:load', extractSwatchColors);

  let swatchDebounce;
  const debouncedExtract = () => {
    clearTimeout(swatchDebounce);
    swatchDebounce = setTimeout(extractSwatchColors, 50);
  };

  const swatchObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-swatch-extracted') {
        const el = mutation.target;
        if (el.hasAttribute('data-swatch-image-url') && !el.hasAttribute('data-swatch-extracted')) {
          debouncedExtract();
          return;
        }
      }
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.('.swatch[data-swatch-image-url]') || node.querySelector?.('.swatch[data-swatch-image-url]'))) {
          debouncedExtract();
          return;
        }
      }
    }
  });
  swatchObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-swatch-extracted'] });
  } catch(e) { console.error(e); }
})();

})();
